import z from "zod";

const id = z.string().transform((value, context) => {
  const parsed = Number(value);

  if (!Number.isInteger(parsed) || parsed <= 0) {
    context.addIssue({
      code: "custom",
      message: "address-id must be a positive integer",
    });

    return z.NEVER;
  }

  return parsed;
});

export const addressMapPopoverDataSchema = z.object({
  addressId: id,
  title: z.string().optional(),
  routeFrom: z.string().optional(),
  mode: z.enum(["drive", "walk", "bicycle", "transit"]).optional(),
  side: z.enum(["top", "right", "bottom", "left"]).optional(),
});

export type AddressMapPopoverDataProps = z.infer<
  typeof addressMapPopoverDataSchema
>;
